/* loader.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./loader.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Spinner from '@atlaskit/spinner';
export var Loader = function Loader() {
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq"])
  }, /*#__PURE__*/React.createElement(Spinner, {
    testId: "forge-app-loading-spinner",
    size: "large"
  }));
};